












































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import ContentsPage from "@/components/ContentsPage.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    BIcon,
    BIconBoxArrowRight,
    ContentsPage,
    Footer,
  },
})
export default class ReadPleasure extends Vue {
  protected contentsRead = [
    {
      ContentsTitle: "POUR RENOUER AVEC LA LECTURE...",
      ContentsPath: "/PlaisirdeLire/RenouerAvecLaLecture",
      ContentsImage: "/thumbnail4.png",
    },
    {
      ContentsTitle: "LES CLASSIQUES",
      ContentsPath: "/PlaisirdeLire/LesClassiques",
      ContentsImage: "/thumbnail5.png",
    },
    {
      ContentsTitle: "TÉMOIGNAGES/ESSAIS",
      ContentsPath: "/PlaisirdeLire/LesEssaisEtTemoignages",
      ContentsImage: "/thumbnail2.png",
    },
    {
      ContentsTitle: "LECTURES INSULAIRES (RÉUNION, HAÏTI)",
      ContentsPath: "/PlaisirdeLire/LectureInsulaire",
      ContentsImage: "/thumbnail1.png",
    },
    {
      ContentsTitle: "LES BANDES DESSINÉES",
      ContentsPath: "/PlaisirdeLire/BandesDessinees",
      ContentsImage: "/thumbnail7.png",
    },
    {
      ContentsTitle: "POUR LES LECTEURS LES PLUS AGUERRIS...",
      ContentsPath: "/PlaisirdeLire/PourLesAguerris",
      ContentsImage: "/thumbnail3.png",
    },
  ];
}
